<template>
  <div
    class="rounded-xl p-10 shadow-primary xl:p-6"
    :class="[mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100']"
  >
    <div
      class="flex items-center justify-between border-b pb-6"
      :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
    >
      <h3 class="text-[22px] font-semibold leading-none sm:text-[18px]">
        {{ title }}
      </h3>
      <span class="text-[14px] font-semibold">0{{ number }}</span>
    </div>
    <div
      v-if="isBodyClasses"
      class="flex items-center justify-between pt-5 sm:flex-col sm:gap-4"
    >
      <slot name="body" />
    </div>
    <slot v-else name="body" />
  </div>
</template>

<script>
export default {
  name: "NumericCard",
  props: {
    mode: String,
    title: String,
    number: Number,
    isBodyClasses: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
